<template>
<div>
    <!--:to="{name:'cloudDetail',params:{id:info.id}}"-->
    <div class="petite-item" @mouseenter="videoPlayback(info.Id,message)" @mouseleave="videoStopped(info.Id,message)">
        <div class="petite-pic">
            <i class="bofang"  v-if="hovernum==message"></i>
            <i class="bofang_img" @click="openPopVideo(info.Id,info.VideoUrl)" v-if="hovernum==message"></i>
                <video :src="info.VideoUrl" :data-src="info.VideoUrl" preload="preload" muted
                 style="width:100%;height:100%;" :data-playId ="info.Id" :data-index="message" class="area" :id="'myVideo'+info.Id"></video>
            </video >
            <div v-if="hovernum !=message">
                <div class="case-tags"></div>
                <span class="tag-views span1"></span><span class="span2"> {{info.PlayCount}} </span>
            </div>
        </div>
        <div class="petite-describe">
            <div class="tou"><img :src="info.HeadImage" alt="" style="width:100%;height: 100%;border-radius: 50%;"></div>
            <b class="ellipsis" :id="'hover444_'+info.Id">{{info.Title}}</b>
            <span class="ellipsis font12">{{info.Title}}</span>
        </div>
    </div>
    <!--视频弹框 显示 +show-->
    <div class="shadow-fixed show" v-show="popVideoDir">
        <div class="mask">
        <div class="mask_top" >
            <div class="bomb-small-close"  @click="closePopVideo"></div>
            <div class="bomb-video-box">
                <video style="width:100%;height:100%;" ref="popVideo" class="video-area" autoplay controls="true"></video>
                <!--播放按钮 显示 +show-->
                <i class="video-icon"></i>
            </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import { playNum } from '../../../../api/index';
export default {
    name: 'petite-item',
    props: {
        info: Object,
        message:Number, 
    },
    data(){
        return{
            popVideoDir:false,
            hovernum:-1,
        }
    },
    methods:{
        //鼠标移进去
         videoPlayback(Id,index){
             var classname = document.getElementById("hover444_"+Id).style.color='#44bb63'
             this.hovernum = index;
             let myVideoList = document.getElementById('myVideo'+Id);
             myVideoList.play();
         },
         //鼠标离开
          videoStopped(Id,index){
              var classname = document.getElementById("hover444_"+Id).style.color='#333'
              this.hovernum = -1
              let myVideoList = document.getElementById('myVideo'+Id);
             myVideoList.pause();
         },
        async openPopVideo(id,vedio) {
            let res = await playNum({
                Id: id,
            });
            this.popVideoDir = true;
            this.$refs.popVideo.src = vedio;
            this.$refs.popVideo.play();

        },
        closePopVideo() {
            this.$refs.popVideo.pause();
            this.popVideoDir = false;
        },
    }
};
</script>

<style>
.tou{width: 36px;float: left;height: 37px;margin-right: 10px;}
.case-column .case-handle{padding-top:3px;}
.bofang{position: absolute;z-index: 8;margin-top: 94px;margin-left: 158px;cursor: pointer;background: black;opacity: 0.5;border-radius: 3px;width: 24px;height: 24px;}
.bofang_img{position: absolute;z-index: 8;margin-top: 95px;margin-left: 159px;background: url("../../../../html/pages/help/contactUs/images/bofang.png") no-repeat center center;width: 22px;height: 22px;display: block;}
video{object-fit: fill}
.bomb-video-box{position: relative;width: 730px;height: 500px;padding-top: 30px;margin: 0 auto;margin-top: 12%;}
.bomb-small-close{position: absolute;top: 7px;right: 0px;z-index: 8;}
.mask_top{position: relative;margin: 0 auto;width: 800px;}
.tag-views{background: url("../../../../html/pages/help/contactUs/images/bo.png") no-repeat center center;width: 12px;height: 12px;display: block;}
.petite-pic{position:relative;}
.case-tags{position: absolute;left: 10px;bottom: 12px;padding: 1px 10px;background: black;opacity: 0.5;height: 18px;width:28px;border-radius: 9px;}
.span1{position: absolute;bottom: 16.5px;left: 19px;}
.span2{position: absolute;bottom: 14px;left: 36px;color: #fff;font-size: 12px;}
</style>
